export default __webpack_public_path__ + "static/media/simple.036aabf4.jpg";